// packages
import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';

// store modules
import members from './members';

// store definition
const store = {
  // state, members, modules, etc
  modules: {
    members,
  },
};

// store
Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [pathify.plugin], // activate plugin
  ...store,
});